var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Cell"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cell",
    clipPath: "url(#clip-Cell)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-phone-portrait",
    "data-name": "Icon ionic-ios-phone-portrait",
    d: "M18.359,1.75H9.685a1.8,1.8,0,0,0-1.81,1.8V24.385a1.853,1.853,0,0,0,1.81,1.865h8.668a1.816,1.816,0,0,0,1.766-1.865V3.549A1.755,1.755,0,0,0,18.359,1.75ZM13.18,3.008H14.82a.219.219,0,0,1,0,.438H13.18a.219.219,0,0,1,0-.437Zm.848,22.422a.952.952,0,1,1,.952-.952A.952.952,0,0,1,14.027,25.43Zm5.113-2.68H8.859a.11.11,0,0,1-.109-.109V4.648a.11.11,0,0,1,.109-.109H19.141a.11.11,0,0,1,.109.109V22.641A.11.11,0,0,1,19.141,22.75Z",
    transform: "translate(1.124 1.25)",
    fill: "#2389d0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCell);
export default __webpack_public_path__ + "static/media/Cell.7bb8bcdafb283ef48df2cdedc4d9aa5d.svg";
export { ForwardRef as ReactComponent };